<template>
  <div class="small-12 medium-12 large-4 columns">
    <div class="row departamentos3 darkcolor" :class="faculdadename">
      <a class="departamentolink"
         :class="faculdadename">
        {{ nome }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Departamento",
  props:["nome","faculdadename"]
}
</script>

<style scoped>
/*114*/
.departamentos3 {
  border: 1px solid;
  text-align: center;
  padding-top: 48px;
  padding-bottom: 158px;
  font-family: "Montserrat Bold";
  font-size: 20px;
  height: 165px;
  padding-left: 30px;
  padding-right: 30px;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
/*127*/
.departamentos3 p{
  margin: 0 auto;
}

@media (min-width : 768px)
and (max-width : 1024px){
  /*244*/
  .departamentos3 {
    padding-bottom: 30px;
    padding-top: 30px !important;
    font-size: 18px;
    height: auto;
    display: flex;
    justify-content: center;
  }


}

@media (max-width: 767px){
  /*299*/
  .departamentos3 {
    padding-bottom: 24px;
    padding-top: 24px !important;
    font-size: 14px;
    height: auto;
  }
}
</style>